var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main-columns",
    {
      scopedSlots: _vm._u([
        {
          key: "rightColumn",
          fn: function() {
            return [_c("notifications")]
          },
          proxy: true
        }
      ])
    },
    [
      _c("div", { staticClass: "va-title" }, [
        _vm._v(_vm._s(_vm.$t("roomWizard.activateDevice")))
      ]),
      !_vm.success
        ? _c("wizard-connect", {
            attrs: { type: "LicenseRegistration", loading: _vm.isLoading },
            on: {
              onFetchConfiguration: function($event) {
                _vm.deviceConfiguration = $event
              }
            }
          })
        : _c("step-complete"),
      _vm.error
        ? _c("va-notification", { attrs: { type: "error" } }, [
            _c("div", [
              _vm._v(" " + _vm._s(_vm.$t("roomWizard.errorActivating")) + " ")
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }